import React, { useState } from 'react';
import { ProfileSettings, NotificationSettings } from '../components/Settings';

const TABS = [
  { id: 'profile', label: 'Profile', component: ProfileSettings },
  { id: 'notifications', label: 'Notifications', component: NotificationSettings },
];

export const ProfilePage = () => {
  const [activeTab, setActiveTab] = useState(TABS[0].id);
  const activeTabData = TABS.find(tab => tab.id === activeTab);
  const ActiveComponent = activeTabData?.component;

  return (
    <div className="settings-wrapper">
      <div className="settings-page">
        <header className="settings-header">
          <div className="settings-header-left">
            <h1 className="settings-title">Account Settings</h1>
            <p className="form-hint" style={{ margin: '4px 0 0' }}>
              Manage your profile, password, and notification preferences.
            </p>
          </div>
        </header>

        <div className="settings-body">
          <nav className="settings-sidebar">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={`settings-tab-btn${activeTab === tab.id ? ' active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </nav>

          <div className="settings-content">
            <div className="settings-content-inner">
              <div className="settings-tab-body">
                {ActiveComponent && <ActiveComponent />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
